import { Directive, ElementRef,HostListener } from '@angular/core';

@Directive({
    selector: '[appNumberFormat]',
    standalone: false
})
export class NumberFormatDirective {

  
  constructor(private el: ElementRef) { 
  }

  @HostListener('blur') onBlurr(){
    const value = parseFloat(this.el.nativeElement.value);    
    if(!isNaN(value)){      
      this.el.nativeElement.value = value.toFixed(2);
    }
  }

}
